
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/temperature/fahrenheit-to-celsius",
      function () {
        return require("private-next-pages/temperature/fahrenheit-to-celsius/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/temperature/fahrenheit-to-celsius"])
      });
    }
  